import React, { useMemo } from 'react';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { GridColDef } from '@mui/x-data-grid-pro';
import { IConfigComponent } from '@ts/ui-models';
import { generateGlobalColumns, generateBasicColumn, IDataGridConfig } from '@ts/storybook';
import { CKPIOperation } from '@ts/ui-models';

import { KPI_OPERATION_CRUDURL, KPI_OPERATION_URL } from './constants';

interface IKpiOperationProps {
  configComponent?: IConfigComponent;
  inheritedProps?: any;
}

export const defaultConfigComponent: IConfigComponent = {
  componentId: 'kpiOperations',
  aclId: 'KpiOp',
  entity: 'kpiOperation',
  fetchURL: KPI_OPERATION_URL,
  crudURL: KPI_OPERATION_CRUDURL,
  mainClass: CKPIOperation,
};

const KpiOperations = (props: IKpiOperationProps) => {
  const { configComponent = defaultConfigComponent } = props;
  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false },
  };

  const getColumns = useMemo((): GridColDef<any>[] => {
    const mixProps = { ...props, configComponent };
    const globalCells = generateGlobalColumns(mixProps);
    return [
      globalCells.id(),
      globalCells.name(),
      generateBasicColumn({ field: 'kpiOperationType', headerName: 'Type' }, { field: 'name', tEntity: 'kpiOperationType' }),
    ];
  }, [props, configComponent]);

  return (
    <WrapperDataGrid
      configComponent={configComponent}
      dataGridConfig={config}
      columns={getColumns}
      //Extra data
      inheritedProps={props.inheritedProps}
    />
  );
};

export default KpiOperations;
